import { Space, Typography, Alert } from 'antd'
import { useShadowWorkflowStatus } from './use-shadow-workflow-status'
import { SummaryCards } from './summary-cards'
import { LastExecutionsTable } from './executions-table'

const { Title } = Typography

export const ShadowWorkflowDashboard: React.FC = () => {
  const { data, isLoading, isError, error, refetch, isFetching } = useShadowWorkflowStatus()

  const executions = data?.executions ?? []
  const summary = data?.summary

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Shadow Workflow Status</Title>
      <Space direction='vertical' size={16} style={{ width: '100%' }}>
        {isError && (
          <Alert
            type='error'
            showIcon
            message='Failed to load'
            description={(error as Error)?.message ?? String(error)}
          />
        )}

        <SummaryCards summary={summary} data={data} isLoading={isLoading} isFetching={isFetching} />

        <LastExecutionsTable
          data={executions}
          loading={isLoading || isFetching}
          onReload={refetch}
        />
      </Space>
    </div>
  )
}
